import fetchRetry from 'fetch-retry';
import { MaxRetryAttempts, RetryBaseDelayMs } from './constants.es.js';

const fetchWithRetries = (input, init, retryCount) => {
    const fetchWithRetry = fetchRetry(fetch);
    return fetchWithRetry(input, Object.assign({ retries: retryCount !== null && retryCount !== void 0 ? retryCount : MaxRetryAttempts, 
        // The default behavior of fetch-retry is to wait a fixed amount of time between attempts.
        // We use exponential backoff
        retryDelay: (attempt) => {
            return Math.pow(2, attempt) * RetryBaseDelayMs; // 0, 300, 600, 1200, 2400, 4800 (ms) = 9300 ms = 9.3s total
        }, 
        // The default behavior of fetch-retry is to only retry requests on network related issues,
        // but we also added the retry on specific HTTP status codes, so it will catch both cases.
        retryOn: [503] }, init));
};

export { fetchWithRetries };
